import { gql } from "@apollo/client";

import { AskAIMeetingEmbedFragment } from "./get-ask-ai-meeting-embed-query";

export const ChatSessionMessageReactionFragment = gql`
  fragment ChatSessionMessageReactionFragment on ChatSessionMessageReactionNode {
    id
    reactionType
    messageId
    creator {
      id
      firstName
      lastName
    }
  }
`;

export const CitationFragment = gql`
  fragment CitationFragment on AnswerCitationNode {
    url
    title
    sourceId
    sourceProvider
    sourceType
    meeting {
      id
      meetingGroupId
      title
      startDatetime
    }
    assessment {
      id
      submittedDatetime
      responder {
        id
        name
        avatar
      }
      template {
        assessmentType
      }
      target {
        id
      }
    }
  }
`;

export const AskAiChatMessageFragment = gql`
  ${AskAIMeetingEmbedFragment}
  ${CitationFragment}
  fragment AskAiChatMessageFragment on ChatMessageNode {
    id
    content
    role
    autogenerated
    error
    isStreaming

    createdArtifact {
      id
    }

    followUps

    outputItems {
      type
      text

      actionItems {
        edges {
          node {
            id
          }
        }
      }
      goals {
        edges {
          node {
            id
          }
        }
      }
      recognitions {
        edges {
          node {
            id
          }
        }
      }
      feedback {
        edges {
          node {
            id
          }
        }
      }

      suggestedAssessmentResponses {
        suggestedResponse
        suggestionId
        citations {
          ...CitationFragment
        }
      }

      suggestedRecognition {
        title
        coreValue {
          id
          title
          emoji
          image
        }
        suggestedAssignee {
          id
          name
          avatar
        }
      }
      suggestedFeedback {
        title
        description
        suggestedAssignee {
          id
          name
          avatar
        }
        recipientsCanView
        recipientsManagersCanView
        adminsCanView
        isDraft
      }
      suggestedActionItem {
        title
        dueDate
        suggestedAssignee {
          id
          name
          avatar
        }
      }
      suggestedGoal {
        title
        suggestedAssignee {
          id
          name
          avatar
        }
        scope
        keyResults
        state
        visibility
      }
      goalProgressUpdates {
        goal {
          id
        }
        suggestedMessage
      }
      overviewDirectReports {
        directReports {
          summary
          user {
            id
            name
            avatar
          }
        }
      }
      overviewUser {
        overview
        goalProgress
        actionItemProgress
        feedbackUpdates
        recognitionsUpdates
        meetingUpdates
        user {
          id
          name
          avatar
        }
      }

      suggestedMeetingTopics {
        topics {
          title
          notes
        }
        meeting {
          ...AskAIMeetingEmbedFragment
        }
      }
      externalEvents {
        eventId
        eventType
        eventData
      }
      meetings {
        edges {
          node {
            ...AskAIMeetingEmbedFragment
          }
        }
      }
    }
  }
`;

export default gql`
  ${ChatSessionMessageReactionFragment}
  ${AskAiChatMessageFragment}
  query getAskAiChatSessionQuery($chatSessionId: Int!) {
    chatSession(chatSessionId: $chatSessionId) {
      id
      updated
      assessment {
        id
        target {
          id
          name
        }
      }
      assessmentQuestion {
        id
        title
      }
      meeting {
        id
        title
      }
      reactions {
        edges {
          node {
            ...ChatSessionMessageReactionFragment
          }
        }
      }
      messages {
        edges {
          node {
            ...AskAiChatMessageFragment
          }
        }
      }
    }
  }
`;
